import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';
import { AlertService, AuthenticationService, UserService } from '../_services/index';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { FacebookService, InitParams, LoginResponse, LoginOptions, AuthResponse } from 'ng2-facebook-sdk';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import { NgxPermissionsService } from 'ngx-permissions';
import { TranslateService } from '@ngx-translate/core';
import { PaymentServices } from '../_services/payment.services';

import * as FullStory from '@fullstory/browser';



@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})

export class LoginComponent implements OnDestroy {
  status: string
  sub: any
  model: any = {};
  loading = false;
  returnUrl: string;
  user = {};
  backendUrl: any;
  id: any;
  secret: any;
  url: any;
  show_link = true;
  showLoginPage = false;
  logo:any="";
  partnerId:any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private http: Http, public fb: FacebookService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private permissionsService: NgxPermissionsService, private translate: TranslateService,
    private paymentService: PaymentServices) { }

  ngOnInit() {
    console.log("check after xomes to landing pagesssssssssssssssssssss");

    let whiteLabelSetting = JSON.parse(localStorage.getItem('whiteLabelSetting'));
    this.partnerId=whiteLabelSetting.partner_id;
    var getPartner=whiteLabelSetting.partner_id;
    console.log("dddddddddddddddddddddddd",this.partnerId,getPartner)

    this.activatedRoute.params.subscribe((params: Params) => {
      let status = (params['logout'] != undefined) ? params['logout'] : 0;
      if (status == 1) {
        this.authenticationService.logout();
      } else {
          let whitelabelSetting=JSON.parse(localStorage.getItem('whiteLabelSetting'))
          if(whitelabelSetting && whitelabelSetting.dashboard){
          let dashboard_setting=whitelabelSetting.dashboard.settings
          this.logo=dashboard_setting.logo
          }else{
            this.logo="assets/img/logo.png"
          }
     
        
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
          // this.backendUrl = environment.url;
        this.id = environment.appid;
        if (localStorage.getItem('id_token') == null) {
          this.http.get(this.backendUrl + '/generate_token', JSON.stringify({}))
            .map(data => data.json())
            .subscribe(data => {
              localStorage.setItem('login_token', data.token);
            }
              // error => {
              //   this.alertService.error(JSON.stringify('Sorry, You are not authorized to access.Please try again.'));
              // }
            );
        } else {
          let currentUser = JSON.parse(localStorage.getItem('currentUser'));
          let u_locale = currentUser.user_locale ? currentUser.user_locale : 'en_US';
          if (u_locale.indexOf("_") != -1) {
            let arr = u_locale.split('_');
            u_locale = arr[0];
          }
          else {
            u_locale = 'en';
          }

          this.translate.setDefaultLang(u_locale);

          let is_first_time_user = currentUser.first_time;
          if (is_first_time_user == 1) {
            this.router.navigate(['wizard']);
          } else {
            this.paymentService.checkPlanActivationStatus({ 'user_id': currentUser.user_id, 'restaurant_id': currentUser.restaurant_id }).subscribe((response: any) => {
              if (response.data.length == 0 && currentUser.role_id != 13) {
                if(this.partnerId == 'd9e20344-0afc-4aa9-adce-615f4ebc6181'){
                  this.router.navigate(['/payment/plans']);
                }else{
                  this.router.navigate(['/profiles']);
                }
              }
              else {
                
                  this.router.navigate(['/profiles']); 
              }

            })

          }
        }
      }
    });

    

    // var hours: any = 24
    // var currentDate: any = new Date()
    // var fullStoryTime: any = localStorage.getItem('full_story_time');
    // if (!fullStoryTime) {
    //   localStorage.setItem('full_story_time', currentDate);
    //   console.log('stroy not found')
    //   FullStory.init({ orgId: 'XMKF3' });
    // }
    // else {
    //   fullStoryTime = new Date(fullStoryTime)
    //   var diff: any = (currentDate - fullStoryTime) / 3600000;
    //   if (parseFloat(hours) >= parseFloat(diff)) {
    //     console.log('stroy found with time true')
    //     FullStory.init({ orgId: 'XMKF3' });
    //   }
    //   else {
    //     console.log('story found with time false')
    //   }
    // }

    window.onload = function (e) {
      // $('.loaders').css({ visibility: "hidden", opacity: 0.9 }).animate({ opacity: 0 }, 500);
    }

  }

  fblogin() {
    this.loading = true;
    this.permissionsService.flushPermissions();
    let u_locale = navigator.language || window.navigator['userLanguage'];
    let utm_source = "Direct"
    let utm_campaign = ""
    let http_referrer = document.referrer;

    if (document.referrer != '') {
      var url = document.referrer;
      var a = new URL(url);
      var b = (a) ? a.hostname : '';
      let domainName = (b && b != '') ? b.substring(0, b.lastIndexOf(".") + 1 - 1) : '';
      domainName = (domainName && domainName != '') ? domainName.substring(domainName.indexOf(".") + 1).split('.')[0] : '';

      if (domainName == '')
        domainName = (b && b != '') ? b.split('.')[0] : ''
      if (domainName == 'stripe' || domainName == '' || domainName == 'foodbot')
        domainName = 'Direct'

      utm_source = domainName
    }



    let fpr = this.route.snapshot.queryParamMap.get("fpr")
    if (fpr && fpr != null && fpr != undefined) {
      utm_source = "Affiliate"
      utm_campaign = fpr
      http_referrer = document.referrer;
    }
    // console.log(u_locale)
    if (u_locale.indexOf("-") != -1) {
      let arr = u_locale.split('-');
      u_locale = arr[0];
    }
    if (u_locale != 'es' && u_locale != 'de') {
      u_locale = 'en';
    }
    console.log(u_locale)
    this.userService.fbLogin(this.backendUrl, this.id, u_locale, utm_source, utm_campaign, http_referrer).then(() => {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));

      let is_first_time_user = currentUser.first_time;
      if (is_first_time_user == 1) {
        let country
        console.log("checkmm here in country ipbhbchbchdchdhcdhcbdhcbhdbchbdc")
        $.getJSON('https://ipapi.co/json/', function (data, textStatus, jqXHR) {
          if (data) {
            console.log("data", data);
            country = data.country_name;
          }
        })
        setTimeout(() => {
          let mailData = {
            'first_name': currentUser.first_name,
            'last_name': currentUser.last_name,
            'email': currentUser.email,
            'signup_date': currentUser.created_at,
            "country": country,
            'stage': 'Signup'
          };
          this.userService.send_mail(this.backendUrl, JSON.stringify({ 'data': mailData }))
            .subscribe(res => {
              console.log(res);
            },
              error => {
                // this.alertService.error(JSON.stringify(error));
              });
        }, 500);

      }
      let perms = currentUser.role_id;
      // let u_locale = currentUser.user_locale ? currentUser.user_locale : 'en_US';

      this.translate.setDefaultLang(u_locale);
      //this.permissionsService.loadPermissions(perms);
      let access_token = localStorage.getItem('access_token');
      this.fb.api('/me/accounts?access_token=' + access_token)
        .then((res: any) => {
          //console.log("res-------",res);
          this.loading = false;
          localStorage.setItem('pagedetails', JSON.stringify(res));
          if (is_first_time_user == 1) {
            this.router.navigate(['wizard']);
          } else {
            this.paymentService.checkPlanActivationStatus({ 'user_id': currentUser.user_id, 'restaurant_id': currentUser.restaurant_id }).subscribe((response: any) => {
              if (response.data.length == 0 && currentUser.role_id != 13) {
                if(this.partnerId == 'd9e20344-0afc-4aa9-adce-615f4ebc6181'){
                  this.router.navigate(['/payment/plans']);
                }else{
                  this.router.navigate(['/profiles']);
                }
              }
              else {
                this.router.navigate(['profiles']);
              }

              var that = this;
              setTimeout(() => {
                that.userService.callComponentMethod({ 'lang': u_locale, 'status': true });
              }, 2000);
            })
            // this.router.navigate(['profiles']);
          }
        }).catch(e =>
          this.alertService.error('Sessions has been timed out, Please login again.'));
      this.loading = false;
        
    }).catch(e =>{
        if(e.status==403){
          this.alertService.error('Access Denied')
          this.loading = false;
        }else{
          this.alertService.error('Sorry, Please try again.')
          this.loading = false;
        }
      
      }
      );
    
  }




  login() {
    this.loading = true;
    localStorage.removeItem('session_id')
    this.authenticationService.login(this.model.useremail, this.model.password, this.backendUrl,this.partnerId)
      .subscribe((res: any) => {
        if (res.login == 'success') {
          var user = res;
          // let perms = [];
          // perms.push(user.role_id);
          // this.permissionsService.loadPermissions(perms);
          let userLang = navigator.language || window.navigator['userLanguage'];
          console.log(userLang)
          localStorage.setItem('currentUser', JSON.stringify(res));
          localStorage.setItem('session_id', Math.random().toString(36).slice(2, 11));
          let currentUser = JSON.parse(localStorage.getItem('currentUser'));
          let u_locale = currentUser.user_locale ? currentUser.user_locale : 'en_US';
          if (u_locale.indexOf("_") != -1) {
            let arr = u_locale.split('_');
            u_locale = arr[0];
          }
          else {
            u_locale = 'en';
          }
          // console.log("locale------",u_locale);
          this.translate.setDefaultLang(u_locale);

          if (res.user_level == 4) {
            this.router.navigate(['invoicescancode']);
          }
          else {
            this.paymentService.checkPlanActivationStatus({ 'user_id': currentUser.user_id, 'restaurant_id': currentUser.restaurant_id }).subscribe((response: any) => {
              if (response.data.length == 0 && currentUser.role_id != 13) {
                if(this.partnerId == 'd9e20344-0afc-4aa9-adce-615f4ebc6181'){
                  this.router.navigate(['/payment/plans']);
                }else{
                  this.router.navigate(['/profiles']);
                }
              }
              else {
                this.router.navigate(['profiles']);
              }

              var that = this;
              setTimeout(() => {
                that.userService.callComponentMethod({ 'lang': u_locale, 'status': true });
              }, 2000);

            })
            // this.router.navigate(['profiles']);
          }
        }
        else if (res.login == 'access_failed') {
          this.alertService.error('User access failed');
          this.loading = false;
        }
        else {
          this.alertService.error('Email or password is invalid');
          this.loading = false;
        }

      },
        error => {
          this.alertService.error('Email or password is invalid.');
          this.loading = false;
        }
      );
  }

  ngAfterViewInit() {
    // (<any>window).Intercom('shutdown');

    // (<any>window).Intercom('update', {
    //   "hide_default_launcher": false
    // });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  hide_link() {
    this.show_link = false;
    this.showLoginPage = true;
  }
}





// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/login/login.component.ts